import { PrimaryTown } from '@propertypal/shared/src/types/show-homes';
import SelectInput from '@propertypal/web-ui/src/inputs/SelectInput';
import { Text } from '@propertypal/web-ui/src/typography';
import router from 'next/router';
import React, { FunctionComponent } from 'react';
import { Container, Content } from './ShowHomesFilterBar.style';

interface Props {
  primaryTowns: PrimaryTown[];
  town: string;
}

const ALL_TOWNS = {
  label: 'All Towns',
  value: '',
};

const ShowHomesFilterBar: FunctionComponent<Props> = (props) => {
  const options = props.primaryTowns
    .map((town) => ({
      label: town.uniqueName,
      value: town.urlComponent,
    }))
    .sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

  const onChange = (value: string) => {
    let url = '/show-home-opening-times';

    if (value) url += `/${value}`;

    router.push(url);
  };

  return (
    <Container>
      <Content>
        <Text fontWeight="bold">Filter by town:</Text>

        <SelectInput
          ariaLabel="Select a town to filter by:"
          containerStyle={{ maxWidth: 300, marginLeft: 10 }}
          id="townSelect"
          options={[ALL_TOWNS, ...options]}
          onChange={onChange}
          value={props.town}
          testID="filterByTown"
        />
      </Content>
    </Container>
  );
};

export default ShowHomesFilterBar;
